import styled from 'styled-components';
import { SUPPORT_ORIGIN } from '../../../../constants/supportArticles';
import { COLOR } from '../../../../styles/colors';

const StyledLinkSet = styled.div`
  /* Should mirror mobile.css */
  /* Force line break after 2nd item (https://stackoverflow.com/questions/29732575/line-break-in-multi-line-flexbox) */

  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  color: ${COLOR.white};
  white-space: nowrap;
  text-transform: uppercase;

  &::after,
  &::before {
    content: '';
    width: 100%;
    order: 1;
    display: block;
  }

  & a {
    color: ${COLOR.white};
    text-decoration: none;
  }
  & a:hover {
    opacity: 0.6;
    cursor: pointer;
  }

  & .item:nth-child(n + 3) {
    order: 1;
  }

  & .item:nth-child(n + 5) {
    order: 2;
  }

  & .item:nth-child(2n)::before {
    content: '|';
    margin: 0 5px;
  }

  & .donotsell {
    flex: 0 0 100%;
  }
  & .donotsell::before {
    content: '';
    margin: 0;
  }

  & .careers,
  & .advertise {
    display: none;
  }

  @media only screen and (min-width: 980px) {
    font-size: 12px;
    font-weight: 600;

    &::before {
      content: none;
    }
    /* reset */
    & .item:nth-child(n) {
      order: 0;
      flex: initial;
    }

    & .item:nth-child(n)::before {
      content: '';
      margin: 0;
    }

    /* + 3 to skip the 'desktop site' link AND the first visual child */
    & .item:nth-child(1n + 3)::before {
      content: '|';
      margin: 0 8px;
    }

    & .desktop-site {
      display: none;
    }

    & .careers,
    & .advertise {
      display: initial;
    }
  }
`;

const EXTERNAL_LINK_ATTRS = {
  target: '_blank',
  rel: 'nofollow noopener noreferrer'
};

const LinkSet = () => (
  <StyledLinkSet>
    <span className="item desktop-site">
      <a href="https://www.maxpreps.com/?persistfull=y">Desktop Version</a>
    </span>
    <span className="item">
      <a href={SUPPORT_ORIGIN} {...EXTERNAL_LINK_ATTRS}>
        Support
      </a>
    </span>
    <span className="item">
      <a href="https://secure.maxpreps.com/utility/member/subscriptions.aspx?ftag=MPM-16-10aaa3j">
        Subscribe
      </a>
    </span>
    <span className="item">
      <a
        href="https://www.viacomcbsprivacy.com/policy"
        {...EXTERNAL_LINK_ATTRS}
      >
        Privacy Policy
      </a>
    </span>
    <span className="item">
      <a
        href="https://www.viacomcbsprivacy.com/cookies"
        {...EXTERNAL_LINK_ATTRS}
      >
        Cookies Policy
      </a>
    </span>
    <span className="item">
      <a
        href="https://legalterms.cbsinteractive.com/terms-of-use"
        {...EXTERNAL_LINK_ATTRS}
      >
        Terms of use
      </a>
    </span>
    <span className="item donotsell">
      <a
        href="https://www.viacomcbsprivacy.com/donotsell"
        {...EXTERNAL_LINK_ATTRS}
      >
        Do Not Sell My Personal Information
      </a>
    </span>
    <span className="item careers">
      <a href="https://www.cbsinteractive.com/careers" {...EXTERNAL_LINK_ATTRS}>
        Careers
      </a>
    </span>
    <span className="item advertise">
      <a
        href="https://cbsinteractive.com/advertising/"
        {...EXTERNAL_LINK_ATTRS}
      >
        Advertise
      </a>
    </span>
  </StyledLinkSet>
);

export default LinkSet;
